export default __webpack_public_path__ + "static/7-3daa2a8d033f814f56a088fb21659a07.jpg";